module.exports = __webpack_public_path__ + "img/ft_lysine.e869838c.jpg";